import React, { useEffect } from "react";
import Header from '../components/Header';
import Footer from '../components/Footer';
import ProductsList from '../DropshipperPages/ProductsList';
import "./PublicProductView.css";

const PublicProductView = () => {
  useEffect(() => {
    if (typeof document === 'undefined') return undefined;
    const originalTitle = document.title;
    document.title = `Products - ${originalTitle}`;

    return () => {
      document.title = originalTitle;
    };
  }, []);

  return (
    <div className="public-product-view-page shared-background">
      <div className="public-product-view-inner">
        <Header />
        <section className="public-product-view-section">
          <div className="public-product-view-panel">
            <ProductsList />
          </div>
        </section>
        <Footer />
      </div>
    </div>
  );
};

export default PublicProductView;
